// The Fields app's destinations, in ONE list.
//
// ⚠️ PURE ON PURPOSE: no components here, so a test can import it. The sidebar,
// the phone menu, the home page's cards, every nav page heading, the child
// pages' breadcrumbs and the tab title all read this list, so they cannot
// disagree. nav.drift.test.ts fails CI when a route, a label or a heading
// drifts from it.
import { Home, MapPin, Map } from 'lucide-react'
import { defineNav, useNavTitleFor, type NavItem } from '@region13/ui'

/** `external` marks the map editor: a page the Worker serves outside this
 *  router, so it needs a plain anchor and has no route here. */
export interface FieldsNavItem extends NavItem {
  external?: boolean
}

export const FIELDS_NAV = defineNav<FieldsNavItem>({
  app: 'Fields',
  items: [
    { to: '/', label: 'Home', icon: Home },
    { to: '/venues', label: 'Venues', icon: MapPin },
    { to: '/map', label: 'Map editor', icon: Map, external: true },
  ],
  groups: [],
  // A venue and a layout take their heading from data, under a breadcrumb to Venues.
  childRoutes: { '/venues/$slug': '/venues', '/layouts/$layoutId': '/venues' },
})

/** The current page's heading: its nav label. */
export const useNavTitle = (): string => useNavTitleFor(FIELDS_NAV)
